export const getDoctorAvailabilityData = (store) =>
  store.DoctorAvailabilityForm.editData;

export const getWeekDayList = (store) =>
  store.DoctorAvailabilityForm.filters.weekDayList;
export const getDoctorList = (store) =>
  store.DoctorAvailabilityForm.filters.doctor;
export const getAreaList = (store) => store.DoctorAvailabilityForm.filters.area;
